import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/card";
import { LoadingSpinner } from "@/components/loading-spinner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
import type { JiraMetricsSyncRun } from "@/http/api-types";
import { formatShortDate } from "./formatters";

export function RecentSyncRunsTable({ rows, isLoading }: { rows: JiraMetricsSyncRun[]; isLoading: boolean }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Recent Sync Runs</CardTitle>
        <CardDescription className="text-sm">History of recent Jira sync runs from BigQuery</CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        {isLoading && <LoadingSpinner />}
        {!isLoading && (
          <div className="h-56 overflow-y-auto">
            <Table>
              <TableHeader className="sticky top-0 bg-background z-10">
                <TableRow>
                  <TableHead className="py-2">Completed</TableHead>
                  <TableHead className="py-2">Rows</TableHead>
                  <TableHead className="py-2">Took</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} className="text-muted-foreground text-center">
                      No sync run history yet.
                    </TableCell>
                  </TableRow>
                )}
                {rows.map(run => (
                  <TableRow key={run.id}>
                    <TableCell className="py-2">{formatShortDate(run.completed_at)}</TableCell>
                    <TableCell className="py-2">
                      {run.rows_upserted}/{run.rows_fetched}
                    </TableCell>
                    <TableCell className="py-2">{run.took_seconds.toFixed(1)}s</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
